/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import {
    Card,
    Col,
    Divider,
    Form,
    Radio,
    Row,
    Checkbox,
    Typography,
    InputNumber
} from 'antd';
import React, { useEffect, useState } from 'react';


import { connect } from 'react-redux';
const { Title, Text } = Typography;




//const { Option } = Select;
const SupportItemsForm = (props) => {

    const {
        Specification,
        partsData,
        setPartsData,
        activeLine,
        supportItemData,
        isEdit

    } = props;

    const [selectedOptions, setSelectedOptions] = useState({
        projectType: 'None',
        grinding_Tool_Consumables_Required: 'No',
        Data360: {
            enabled: false,
            selected: [] // ['Data 360'] when checked
        },
        InductionPreheat: {
            enabled: false,
            option: ['MillerProheat'], // available options (2 if you add more)
            selected: [] // checked items go here
        },
        DMAG: {
            enabled: false,
            option: ['MILLER', 'GYS'],
            selected: [] // checked items (MILLER, GYS) go here
        },
        Plasmacutting: {
            enabled: false,
            selected: [] // ['plasma cutting'] when checked
        },
        PPE: {
            Required: "No",
            Project_Duration: 0,
            Mainline_Welders: 0,
            Repair_Welders: 0,
            Bevel_Machine_Operators: 0,
            Technicians:0,
            General_Helper: 0,
            Air_Fed_Welding_Hood: "No",
            Non_Air_Fed_Hood: "No",
            Cool_Vest: "No"
        }   

    });
    // Restore from API (supportItemData) or from partsData when switching lines
    useEffect(() => {
        const lineKey = `Line_${activeLine + 1}`;
        const fromPartsData = partsData?.[lineKey]?.SupportItemData;

        // Prefer edit API data; otherwise use existing partsData for this line
        if (isEdit && supportItemData) {
            const data = supportItemData[activeLine]?.SupportItem;
            const sd = data?.SupportData;
            console.log('sd', sd)
            if (data) {
                setSelectedOptions({
                    projectType: data.ProjectType ?? '',
                    grinding_Tool_Consumables_Required: data.Grinding_tool_consumables_required ?? '',
                    Data360: {
                        enabled: sd?.Data360?.enabled ?? false,
                        selected: Array.isArray(sd?.Data360?.selected) ? sd.Data360.selected : (sd?.Data360?.enabled ? ['Data 360'] : []),
                    },
                    InductionPreheat: {
                        enabled: sd?.InductionPreheat?.enabled ?? false,
                        option: sd?.InductionPreheat?.option ?? ['MillerProheat'],
                        selected: sd?.InductionPreheat?.enabled ? (Array.isArray(sd?.InductionPreheat?.selected) ? sd.InductionPreheat.selected : []) : [],
                    },
                    DMAG: {
                        enabled: sd?.DMAG?.enabled ?? false,
                        option: sd?.DMAG?.option ?? ['MILLER', 'GYS'],
                        selected: sd?.DMAG?.enabled ? (Array.isArray(sd?.DMAG?.selected) ? sd.DMAG.selected : []) : [],
                    },
                    Plasmacutting: {
                        enabled: sd?.Plasmacutting?.enabled ?? false,
                        selected: Array.isArray(sd?.Plasmacutting?.selected) ? sd.Plasmacutting.selected : (sd?.Plasmacutting?.enabled ? ['plasma cutting'] : []),
                    },
                    PPE: data.PPE ?? {
                        Required: "No",
                        Project_Duration: 0,
                        Mainline_Welders: 0,
                        Repair_Welders: 0,
                        Bevel_Machine_Operators: 0,
                        Technicians: 0,
                        General_Helper: 0,
                        Air_Fed_Welding_Hood: "No",
                        Non_Air_Fed_Hood: "No",
                        Cool_Vest: "No"
                    }
                });
                return;
            }
        }

        // if (fromPartsData && typeof fromPartsData.Data360 === 'object' && typeof fromPartsData.DMAG === 'object') {
        //     setSelectedOptions((prev) => ({
        //         ...prev,
        //         projectType: fromPartsData.projectType ?? prev.projectType,
        //         grinding_Tool_Consumables_Required: fromPartsData.grinding_Tool_Consumables_Required ?? prev.grinding_Tool_Consumables_Required,
        //         Data360: { ...prev.Data360, ...fromPartsData.Data360, option: fromPartsData.Data360?.option ?? (fromPartsData.Data360?.enabled ? ['Data 360'] : []) },
        //         InductionPreheat: { ...prev.InductionPreheat, ...fromPartsData.InductionPreheat, option: fromPartsData.InductionPreheat?.option ?? (fromPartsData.InductionPreheat?.enabled ? ['MillerProheat'] : []) },
        //         DMAG: { ...prev.DMAG, ...fromPartsData.DMAG, option: fromPartsData.DMAG?.option ?? (fromPartsData.DMAG?.enabled ? ['MILLER', 'GYS'] : []), selected: fromPartsData.DMAG?.selected ?? [] },
        //         PLASMA: { ...prev.PLASMA, ...fromPartsData.PLASMA, option: fromPartsData.PLASMA?.option ?? (fromPartsData.PLASMA?.enabled ? ['plasma cutting'] : []) },
        //         PPE: fromPartsData.PPE ?? prev.PPE
        //     }));
        // }
    }, [supportItemData, activeLine])
    useEffect(() => {
        if (Specification) {

            setPartsData((prevOptions) => {

                return {
                    ...prevOptions,
                    [`Line_${activeLine + 1}`]: {
                        ...prevOptions[`Line_${activeLine + 1}`],
                        SupportItemData: selectedOptions,
                    },
                };
            });
        }
    }, [selectedOptions, Specification, activeLine]);

    const handleRadioChange = (category, value) => {
        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                [category]: value
            };
        });
    };

    const getCategoryValue = (category) => {

        if (selectedOptions.hasOwnProperty(category)) { // Check if the category exists in selectedOptions
            return selectedOptions[category]; // Return the value for the category
        } else {
            return null; // Return null if the category does not exist
        }
    };
    const getCategoryValue1 = (type) => {
        if (selectedOptions.hasOwnProperty('PPE')) { // Check if the category exists in selectedOptions
            return selectedOptions['PPE'][type]; // Return the value for the category
        } else {
            return null; // Return null if the category does not exist
        }
    };
    const getPPRequiredValue = (type) => {
        if (selectedOptions.hasOwnProperty('PPE')) { // Check if the category exists in selectedOptions
            return selectedOptions['PPE']['Required']; // Return the value for the category
        } else {
            return 'No'; // Return null if the category does not exist
        }
    };

    const handleInputChange = (type, values) => {
        const category = 'PPE'
        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                [category]: {
                    ...prevOptions[category],
                    [type]: values,
                },
            };
        });
    };
    // const handleBlur = (row, col, value) => {
    //     // Ensure the value is not empty, set it to 0 if it is
    //     if (value === '') {
    //         handleInputChange(row, col, 0);
    //     }
    // };



    return (

        <div>

            <div style={{ marginTop: '-10px' }}>
                <Row justify="start">
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="mb-0" style={{ fontSize: '18px' }}>Specification :</p>

                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">Pipe Size(inch)</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col1}</p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">Wall Thickness(mm)</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col2}</p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">No. of Welds</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col3}</p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">No. of Station</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col4}</p>
                            </div>
                        </div>
                    </Col>



                </Row>
            </div>
            <div className="custom-line" style={{ marginTop: '-10px' }} />
            <Form

                name="basic"
                autoComplete="off"
                width='100%'
                layout="vertical"
                style={{ marginTop: '-10px' }}
            >


                <Card className='custom-card5' title='Project Type'
                    style={{ background: 'rgba(255, 255, 255, 0.08)', borderColor: 'rgba(255, 255, 255, 0.15)', minHeight: '400px', borderRadius: 12 }}
                    bodyStyle={{ padding: '24px 20px' }}
                >
                    <Row gutter={[16, 16]} align="top">
                        {/* Left: Project settings — strict label/control alignment */}
                        <Col xs={24} lg={9}>
                            <div className="support-items-form-section" style={{
                                display: 'grid',
                                gridTemplateColumns: '220px 1fr',
                                gap: '18px 16px',
                                alignItems: 'center',
                                maxWidth: 420
                            }}>
                                <span style={{ fontSize: 14, fontWeight: 500, opacity: 0.95 }}>Types</span>
                                <Radio.Group
                                    value={getCategoryValue('projectType')}
                                    onChange={(e) => handleRadioChange('projectType', e.target.value)}
                                    style={{ display: 'flex', gap: 16 }}
                                >
                                    <Radio value='Onshore'>Onshore</Radio>
                                    <Radio value='Offshore'>Offshore</Radio>
                                    <Radio value='None'>None</Radio>
                                </Radio.Group>

                                <span style={{ fontSize: 14, fontWeight: 500, opacity: 0.95 }}>Grinding tool consumables required?</span>
                                <Radio.Group
                                    value={getCategoryValue('grinding_Tool_Consumables_Required')}
                                    onChange={(e) => handleRadioChange('grinding_Tool_Consumables_Required', e.target.value)}
                                    style={{ display: 'flex', gap: 16 }}
                                >
                                    <Radio value='Yes'>Yes</Radio>
                                    <Radio value='No'>No</Radio>
                                </Radio.Group>

                                <span style={{ fontSize: 14, fontWeight: 500, opacity: 0.95 }}>PPE Required</span>
                                <Radio.Group
                                    value={getPPRequiredValue()}
                                    onChange={(v) => handleInputChange('Required', v.target.value)}
                                    style={{ display: 'flex', gap: 16 }}
                                >
                                    <Radio value='Yes'>Yes</Radio>
                                    <Radio value='No'>No</Radio>
                                </Radio.Group>
                            </div>
                        </Col>

                        {/* Middle: PPE details — compact grid, aligned labels */}
                        <Col xs={24} lg={8}>
                            {getPPRequiredValue('Required') === 'Yes' && (
                                <div style={{
                                    background: 'rgba(255,255,255,0.06)',
                                    borderRadius: 8,
                                    padding: '16px 14px',
                                    border: '1px solid rgba(255,255,255,0.08)'
                                }}>
                                    <Text style={{ fontSize: 16, fontWeight: 600, opacity: 0.9, letterSpacing: '0.5px', display: 'block', marginBottom: 14 }}>Personnel & duration</Text>
                                    <Row gutter={[10, 12]}>
                                        {[
                                            { key: 'Project_Duration', label: 'Project Duration (Weeks)' },
                                            { key: 'Mainline_Welders', label: 'Mainline Welders' },
                                            { key: 'Repair_Welders', label: 'Repair Welders' },
                                            { key: 'Bevel_Machine_Operators', label: 'Bevel Machine Operators' },
                                            { key: 'Technicians', label: 'Technicians' },
                                            { key: 'General_Helper', label: 'General / Helper' }
                                        ].map(({ key, label }) => (
                                            <Col span={12} key={key}>
                                                <Form.Item label={label} style={{ marginBottom: 0 }} labelCol={{ style: { fontSize: 12 } }}>
                                                    <InputNumber
                                                        type="number"
                                                        size="middle"
                                                        value={getCategoryValue1(key)}
                                                        min={0}
                                                        max={1000}
                                                        onChange={(v) => handleInputChange(key, v)}
                                                        style={{ width: '100%' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        ))}
                                    </Row>
                                    <Divider style={{ borderColor: 'rgba(255,255,255,0.12)', margin: '14px 0 12px' }} />
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px 20px', alignItems: 'center' }}>
                                        <Checkbox
                                            checked={getCategoryValue1('Air_Fed_Welding_Hood') === 'Yes'}
                                            onChange={(e) => handleInputChange('Air_Fed_Welding_Hood', e.target.checked ? 'Yes' : 'No')}
                                            style={{ marginLeft: 0, whiteSpace: 'nowrap' }}
                                        >Air Fed Welding Hood</Checkbox>
                                        <Checkbox
                                            checked={getCategoryValue1('Non_Air_Fed_Hood') === 'Yes'}
                                            onChange={(e) => handleInputChange('Non_Air_Fed_Hood', e.target.checked ? 'Yes' : 'No')}
                                            style={{ marginLeft: 0, whiteSpace: 'nowrap' }}
                                        >Non Air Fed Hood</Checkbox>
                                        <Checkbox
                                            checked={getCategoryValue1('Cool_Vest') === 'Yes'}
                                            onChange={(e) => handleInputChange('Cool_Vest', e.target.checked ? 'Yes' : 'No')}
                                            style={{ marginLeft: 0, whiteSpace: 'nowrap' }}
                                        >Cool Vest</Checkbox>
                                    </div>
                                </div>
                            )}
                        </Col>

                        {/* Right: Equipment — list with consistent spacing and indent */}
                        <Col xs={24} lg={6}>
                            <div style={{
                                background: 'rgba(255,255,255,0.06)',
                                borderRadius: 8,
                                padding: '16px 14px',
                                border: '1px solid rgba(255,255,255,0.08)'
                            }}>
                                <Text style={{ fontSize: 16, fontWeight: 600, opacity: 0.9, letterSpacing: '0.5px', display: 'block', marginBottom: 14 }}>Equipment</Text>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 18, width: '100%' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
                                        <Checkbox
                                            checked={selectedOptions.Data360?.enabled || false}
                                            onChange={(e) => setSelectedOptions((prev) => ({
                                                ...prev,
                                                Data360: { ...prev.Data360, enabled: e.target.checked, selected: e.target.checked ? ['Data 360'] : [] }
                                            }))}
                                            style={{ marginRight: 10 }}
                                        />
                                        <span style={{ fontSize: 14 }}>Data 360</span>
                                    </label>

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
                                            <Checkbox
                                                checked={selectedOptions.InductionPreheat?.enabled || false}
                                                onChange={(e) => setSelectedOptions((prev) => ({
                                                    ...prev,
                                                    InductionPreheat: {
                                                        ...prev.InductionPreheat,
                                                        enabled: e.target.checked,
                                                        option: e.target.checked ? (prev.InductionPreheat?.option?.length ? prev.InductionPreheat.option : ['MillerProheat']) : [],
                                                        MillerProheat: e.target.checked ? (prev.InductionPreheat?.MillerProheat || "MillerProheat") : ""
                                                    }
                                                }))}
                                                style={{ marginRight: 10 }}
                                            />
                                            <span style={{ fontSize: 14 }}>Induction Preheat</span>
                                        </label>
                                        {selectedOptions.InductionPreheat?.enabled && (
                                            <div style={{ paddingLeft: 34 }}>
                                                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
                                                    <Checkbox
                                                        checked={!!selectedOptions.InductionPreheat?.MillerProheat || (selectedOptions.InductionPreheat?.option?.includes?.('MillerProheat'))}
                                                        onChange={(e) => setSelectedOptions((prev) => ({
                                                            ...prev,
                                                            InductionPreheat: {
                                                                ...prev.InductionPreheat,
                                                                MillerProheat: e.target.checked ? "MillerProheat" : "",
                                                                option: e.target.checked ? ['MillerProheat'] : []
                                                            }
                                                        }))}
                                                        style={{ marginRight: 10 }}
                                                    />
                                                    <span style={{ fontSize: 13, opacity: 0.95 }}>Miller Proheat</span>
                                                </label>
                                            </div>
                                        )}
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
                                            <Checkbox
                                                checked={selectedOptions.DMAG?.enabled || false}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setSelectedOptions((prev) => ({
                                                        ...prev,
                                                        DMAG: {
                                                            ...prev.DMAG,
                                                            enabled: checked,
                                                            option: prev.DMAG?.option ?? ['MILLER', 'GYS'],
                                                            selected: checked ? ['MILLER', 'GYS'] : []
                                                        }
                                                    }));
                                                }}
                                                style={{ marginRight: 10 }}
                                            />
                                            <span style={{ fontSize: 14 }}>DMAG</span>
                                        </label>
                                        {selectedOptions.DMAG?.enabled && (
                                            <div style={{ paddingLeft: 34, display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '16px 24px', alignItems: 'center' }}>
                                                {(selectedOptions.DMAG?.option || ['MILLER', 'GYS']).map((opt) => (
                                                    <label key={opt} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
                                                        <Checkbox
                                                            checked={(selectedOptions.DMAG?.selected || []).includes(opt)}
                                                            onChange={(e) => {
                                                                const selected = selectedOptions.DMAG?.selected || [];
                                                                const next = e.target.checked
                                                                    ? [...selected, opt]
                                                                    : selected.filter((v) => v !== opt);
                                                                setSelectedOptions((prev) => ({
                                                                    ...prev,
                                                                    DMAG: { ...prev.DMAG, selected: next }
                                                                }));
                                                            }}
                                                            style={{ marginRight: 10 }}
                                                        />
                                                        <span style={{ fontSize: 13, opacity: 0.95 }}>{opt === 'MILLER' ? 'Miller' : opt}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
                                        <Checkbox
                                            checked={selectedOptions.Plasmacutting?.enabled || false}
                                            onChange={(e) => setSelectedOptions((prev) => ({
                                                ...prev,
                                                Plasmacutting: { ...prev.Plasmacutting, enabled: e.target.checked, option: e.target.checked ? ['plasma cutting'] : [] }
                                            }))}
                                            style={{ marginRight: 10 }}
                                        />
                                        <span style={{ fontSize: 14 }}>Plasma Cutting</span>
                                    </label>
                                </div>
                            </div>
                        </Col>
                    </Row>



                </Card>
            </Form>


        </div>
    );
};



export default connect(null, null)(SupportItemsForm);

